var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFilter(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 22 22' }, props),
        React.createElement("path", { d: 'M2 .5l-.13.005C.725.6.09 1.93.79 2.885l6.843 9.363V20a1.5 1.5 0 002.107 1.372l4.033-1.784.131-.066a1.5 1.5 0 00.762-1.306l-.001-5.985 6.564-9.37C21.925 1.865 21.214.5 20 .5H2zM20 2l-6.834 9.758v6.458L9.133 20v-8.242L2 2h18z' })));
}
export default SvgFilter;
//# sourceMappingURL=Filter.js.map